import { useSWR } from '@/apis'
import { reqApiAgentTimeline } from '@/apis/ok'
import { toast } from '@/ui/useToastStore'
import { useEffect, useMemo, useState } from 'react'
import { useCommon } from '@/core/useCommon'
import { ROUTES } from '@/env/routes'

// 待審核、待出款、今日出款、今日充值的 hook
export const usePaymentOverview = () => {
  const { t } = useCommon()

  // 通知事件列表
  const [notifyEvents, setNotifyEvents] = useState<OK_API_AGENT_TIMELINE.RES['t']['notifyEvents']>([])

  // timeline api query
  const timelineQuery = useSWR<OK_API_AGENT_TIMELINE.RES>('/timeline', reqApiAgentTimeline)

  // 待審核、待出款、今日出款、今日充值
  const overviewMaps = useMemo(() => {
    const timeline = timelineQuery?.data?.t
    return {
      // 待審核
      pendingReview: {
        label: t('old:pendingReview'),
        value: timeline?.withdrawVO?.reviewNum ?? 0,
        link: ROUTES.WITHDRAW_LIST(),
      },
      // 待出款
      pendingPayment: {
        label: t('old:pendingPayment'),
        value: timeline?.withdrawVO?.pendingPaymentNum ?? 0,
        link: ROUTES.WITHDRAW_LIST(),
      },
      // 今日出款
      todayWithdrawNum: {
        label: t('old:todayWithdrawNum'),
        value: timeline?.withdrawVO?.withdrawTodayNum ?? 0,
        link: ROUTES.WITHDRAW_LIST(),
      },
      // 今日充值
      todayRechNum: {
        label: t('old:todayRechNum'),
        value: timeline?.rechVO?.rechTodayNum ?? 0,
        link: ROUTES.RECHARGE_LIST(),
      },
    }
  }, [t, timelineQuery?.data?.t])

  // 有通知的時候要通知
  useEffect(() => {
    if (!timelineQuery.data?.t?.notifyEvents?.length) return

    // 新的通知列表
    setNotifyEvents((preState) => {
      const newEvents = timelineQuery.data?.t?.notifyEvents || []

      return [...preState, ...newEvents]
    })
  }, [timelineQuery.data?.t?.notifyEvents])

  // 一次一個 toast 來通知
  useEffect(() => {
    if (!notifyEvents.length) return

    // 6秒後自動顯示下一個通知
    const timer = setTimeout(() => {
      const event = notifyEvents[0]

      if (event?.notifyContent) {
        toast(event?.notifyContent)
      }

      // 顯示完後從列表移除
      setNotifyEvents((preState) => preState.slice(1))
    }, 6000)

    return () => clearTimeout(timer)
  }, [notifyEvents])

  return {
    // timeline api query
    timelineQuery,
    // 新的通知列表
    notifyEvents,
    // 待審核、待出款、今日出款、今日充值
    overviewMaps,
  }
}
